import React from 'react';

import { IconButton } from '@mui/material';
import { AlineTooltip, setForwardDocumentDialogState } from 'src/components';
import { GroupIcon } from 'src/components/icons/GroupIcon';
import { shareDialogOpenVar } from 'src/editor/AlineEditor';
import { Apollo } from 'src/gql/generated';
import { useGetCurrentDoc } from 'src/hooks';

interface VersionHistoryButtonProps {
  documentId: UUID;
  disabled?: boolean;
}

export function EditCollaboratorsButton({ disabled }: VersionHistoryButtonProps): JSX.Element {
  const { document } = useGetCurrentDoc();
  const isEditor = document?.requesterRole === Apollo.PermissionRole.Editor;

  return (
    <AlineTooltip arrow placement="bottom" title="Edit collaborators">
      <div>
        <IconButton
          aria-label="Edit collaborators"
          disabled={disabled}
          size="small"
          onClick={() => {
            return isEditor
              ? shareDialogOpenVar(true)
              : setForwardDocumentDialogState({ open: true });
          }}
        >
          <GroupIcon />
        </IconButton>
      </div>
    </AlineTooltip>
  );
}
